import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { useGetProjectInfoQuery, RTK_QUERY_OPTIONS } from 'apiv2'
import { usePrevilegies } from 'hooks/usePrevilegies'
import { currentUserSelector } from 'store/users'
import { USER_ROLE } from 'utils/constants'

const { DISABLE_REFETCH_ON_FOCUS } = RTK_QUERY_OPTIONS
const { MANAGER } = USER_ROLE

export const useProjectPermissions = (customSlug = null, queryOptions = {}) => {
  const router = useRouter()
  const currentUser = useSelector(currentUserSelector)

  const projectSlug = customSlug || router.query.projectSlug

  const {
    data: projectInfo,
    isLoading: isProjectInfoLoading,
    isSuccess,
  } = useGetProjectInfoQuery(projectSlug, {
    DISABLE_REFETCH_ON_FOCUS,
    ...queryOptions,
    skip: !projectSlug || queryOptions.skip,
  })

  const hasActiveProject = !!projectSlug && !!projectInfo

  const { isManager, isAdmin, isSuperAdmin } = usePrevilegies()

  const isProjectManager = !!projectInfo?.users?.some(
    (user) => user.id === currentUser?.id && user.role?.id === MANAGER
  )

  const isManagerOrAdmin = isAdmin || isProjectManager

  const canEditProject = !!projectInfo?.capabilities?.includes('edit_project')
  const canShowDashboard =
    !!projectInfo?.capabilities?.includes('show_dashboard')
  const canEditProjectPerms =
    projectInfo?.capabilities?.includes('edit_project_perms')

  return {
    hasActiveProject,
    isProjectManager,
    isManagerOrAdmin,
    canEditProject,
    canShowDashboard,
    canEditProjectPerms,
    isManager,
    isAdmin,
    isSuperAdmin,
    projectInfo,
    projectSlug,
    isProjectInfoLoading,
    isSuccess,
  }
}
